import axios from "axios";
import router from "@/router";
import { ElMessageBox, ElLoading } from "element-plus";
import { resetMessage as Message } from "../resetMessage";
import { getTicket } from "@/api/common";
import { signmd5, encrypt, decrypt } from "@/utils/util";
import { sessionKey } from "@/utils/auth";
import { loadEnv } from "@build/index";
import { RedirectPath, PureHttpRequestConfig } from "./types";
import { useUserStoreHook } from "@/store/modules/user";
import { storageSession } from "@pureadmin/utils";
let loadingInstance;
const { VITE_BASE_API } = loadEnv();

const EXPIRE_TIME = 29 * 60 * 1000; // ticket失效时间

const tipErr = "服务开小差了，请稍后重试";
// 如果用户是登录失效后，再次刷新页面
if (localStorage.getItem("flagMess")) {
  showLoginFail();
}
// 显示登录报错信息
function showLoginFail() {
  ElMessageBox.alert("登录失效，请重新登录", "确认登录信息", {
    confirmButtonText: "重新登录",
    showClose: false,
    callback: () => {
      localStorage.c_mobile = "";
      localStorage.c_countryCode = "";
      localStorage.removeItem("flagMess");
      useUserStoreHook().logOut(true);
    }
  });
}

const handleTicket = async (isExpire = false) => {
  const c_ticket = sessionStorage.c_ticket;
  try {
    if (c_ticket && !isExpire) {
      const [ticket, time] = c_ticket.split("?");
      const now = new Date().getTime();
      if (!time || now - time >= EXPIRE_TIME) {
        sessionStorage.c_ticket = "";
        await fetchTicket();
      }
    } else {
      await fetchTicket();
    }
    return true;
  } catch (error) {
    return false;
  }
};

const fetchTicket = async () => {
  try {
    sessionStorage.c_ticket = "";
    const { ticket } = await getTicket();
    const newTime = new Date().getTime();
    sessionStorage.c_ticket = `${ticket}?${newTime}`;
    return ticket;
  } catch (error) {
    return "";
  }
};

const getTicketCache = () => {
  const c_ticket = sessionStorage.c_ticket ?? "";
  const [ticket] = c_ticket.split("?");
  return ticket;
};

// 1. 创建axios实例
const http = axios.create({
  baseURL: VITE_BASE_API,
  // withCredentials: true, // 跨域时若要发送cookies需设置该选项
  timeout: 600000 // 超时
});
// 请求拦截

const noSignList = ["enclosureUpload", "enclosureOcrUpload"];
http.interceptors.request.use(
  async (config: PureHttpRequestConfig) => {
    const loadText = config.loadText || "拼命加载中";
    if (!config.noLoading) {
      loadingInstance = ElLoading.service({
        lock: false,
        text: loadText,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    }
    // console.log('请求参数Config', config);
    const arr = Object.keys(config.data);
    arr.forEach(item => {
      if (typeof config.data[item] == "object") {
        config.data[item] = JSON.stringify(config.data[item]);
      }
    });
    config.originData = {
      url: config.url,
      data: JSON.parse(JSON.stringify(config.data)),
      config: { headers: config.headers }
    };
    console.log("转换请求参数", config.url, config.data);
    if (config.url!.includes("ticket/getTicket")) {
      // 是获取票据信息接口时不需要加密
      config.data = signmd5(config.data);
    } else {
      // 每次请求先判断tikect是否过期
      await handleTicket();
      if (getTicketCache()) {
        // 需要加密的
        if (!noSignList.some(item => config.url!.includes(item))) {
          // AES 加密处理
          const encryptData = encrypt(signmd5(config.data), getTicketCache());
          const obj = {
            reqParams: encryptData
          };
          config.data = obj;
        }
      }
    }
    config.headers["ticket"] = getTicketCache();
    // token附加
    // console.log(
    //   "storageSession.getItem(sessionKey)",
    //   storageSession.getItem(sessionKey)
    // );
    const _userToken = storageSession.getItem(sessionKey)?.userToken;

    if (_userToken) {
      // 设置令牌请求头
      // config.headers["Authorization"] = 'Bearer ' + getToken();
      config.headers["user_token"] = _userToken;
    }
    // let flagMess = localStorage.getItem('flagMess'); // 登录态失效单例
    return config;
  },
  error => {
    // 请求错误预处理
    //console.log(error) // for debug
    loadingInstance && loadingInstance.close();
    return Promise.reject(error);
  }
);

// MESTAMP_LACK("时间戳为空"),
// PARAM_LACK("缺少参数"),
// PARAM_ERROR("参数错误"),
// TICKET_LACK("ticket缺失"),
// TICKET_EXPIRED("ticket已过期"),
// DECRYPT_FAIL("数据解密失败"),
// INVALID_REQUEST("非法请求"),
// SYSTEM_ERROR("系统错误"),
// SIGN_ERROR("签名错误"),
// LOGIN_EXPIRED("登录失效，请重新登录"),
// HYSTRIX_FALLBACK( "服务开小差了，请稍后再试"),
// NO_SERVER("未找到服务器，请稍后再试"),

// 响应拦截
http.interceptors.response.use(
  // 通过自定义code判定响应状态，也可以通过HTTP状态码判定
  async response => {
    loadingInstance && loadingInstance.close();
    // 仅返回数据部分
    const res = response.data;
    const config = response.config;

    if (res.returnCode && res.returnCode == "SUCCESS") {
      // 解密处理
      const result = JSON.parse(decrypt(res.responseParams, getTicketCache()));
      console.log("响应数据", response.config.url, result);
      localStorage.removeItem("flagMess");
      if (result.resultCode !== "SUCCESS") {
        Message({
          message: result.errorCodeDes || tipErr,
          type: "error",
          duration: 2 * 1000
        });

        return Promise.resolve(result.errorCodeDes || tipErr);
        // return;
      }

      return result;
    } else if (
      (res.resultCode && res.resultCode !== "SUCCESS") ||
      (res.returnCode && res.returnCode !== "SUCCESS")
    ) {
      // 登录失效，请重新登录
      if (res.errorCode == "LOGIN_EXPIRED") {
        const flagMess = localStorage.getItem("flagMess");
        console.log("登录失效", flagMess);
        if (!flagMess) {
          localStorage.setItem("flagMess", "true");
          showLoginFail();
        }
        return;
      }
      // ticket 过期逻辑处理
      if (res.errorCode == "TICKET_EXPIRED") {
        sessionStorage.c_ticket = "";
        debugger;
        const result = await http.post(
          config.originData.url,
          config.originData.data,
          config.originData.config
        );
        return result;
      }
      Message({
        message: res.errorCodeDes || tipErr,
        type: "error",
        duration: 2 * 1000
      });
      return Promise.reject(res.errorCodeDes || tipErr);
    } else {
      return res;
    }
  },
  error => {
    //console.log("err" + error); // for debug
    loadingInstance && loadingInstance.close();
    Message({
      message: error.message,
      type: "error",
      duration: 2 * 1000
    });
    return Promise.reject(error);
  }
);

export default http;
